export default __webpack_public_path__ + "static/media/done-icon.830cc47c.svg";